import { DefaultTheme } from 'styled-components';

export const regularTheme: DefaultTheme = {
  colors: {
    primaryBackground: '#e9eef0',
    primaryBackgroundA80: 'rgb(233, 238, 240, 0.8)',
    secondaryBackground: 'white',
    secondaryBackgroundB95: 'rgb(242, 242, 242)',
    tertiaryBackground: '#c8d5db',
    quaternaryBackground: '#d7e1e5',
    senaryBackground: '#f6f8f9',
    lightBackground: '#f8f8f8',
    primary: '#00e4e0',
    primaryText: '#00364d',
    primaryTextRGB: '0, 54, 77',
    secondaryText: '#5a879a',
    tertiaryText: '#457387',
    quaternaryText: '#9db4be',
    quaternaryTextA85: 'rgba(181, 199, 207, 0.85)',
    quinaryText: '#32657b',
    senaryText: '#7b9ead',
    icon: '#0b4f6c',
    lightIcon: '#82a3b1',
    primaryBorder: '#d3d3d3',
    secondaryBorder: '#b5c7cf',
    tertiaryBorder: '#00c8bf',
    warningBorder: '#eeac2b',
    checkboxOutline: '#b8b8b8',
    gridAltRow: '#f5f5f5',
    draft: '#ccbaa8',
    pending: '#e68792',
    approved: '#45b3ad',
    alert: '#ff0000',
    error: '#be2728',
    notificationBarBackground: '#fdf7e2',
    notificationBarText: '#99650b',
    disabledBackground: '#f6f8f9',
    activeBackground: '#96eeec',
    darkBackground: '#00415c',
    reportContainerBackground: '#F2F2F2',
    reportSysPrinSelectorBackground: '#D7E1E5',
    reportSearchCriteriaBackground: '#D8D8D8',
    landingPageCardSecondary: '#0c4f6c',
    darkRed: '#911106',
    darkGreen: '#186604',
    darkYellow: '#ffd43b',
    orange: '#ff7f27',
    endingBlue: '#177e9f',
  },
  fonts: {
    regular: 'notoSans',
    medium: 'notoSans-medium',
    semiBold: 'notoSans-semiBold',
    // TODO: Once we have the proper font we should change this.
    bold: 'notoSans-semiBold',
  },
};

export const darkTheme: DefaultTheme = {
  colors: {
    primaryBackground: '#161A1D',
    primaryBackgroundA80: 'rgb(22, 26, 29, 0.8)',
    secondaryBackground: '#0B090A',
    secondaryBackgroundB95: 'rgb(242, 242, 242)',
    tertiaryBackground: '#660708',
    quaternaryBackground: '#0B090A',
    senaryBackground: '#090706',
    lightBackground: '#f8f8f8',
    primary: '#E5383B',
    primaryText: '#F5F3F4',
    primaryTextRGB: '245, 243, 244',
    secondaryText: '#B1A7A6',
    tertiaryText: '#D3D3D3',
    quaternaryText: '#D3D3D3',
    quaternaryTextA85: 'rgba(211, 211, 211, 0.85)',
    quinaryText: '#D3D3D3',
    senaryText: '#7b9ead',
    icon: '#F5F3F4',
    lightIcon: '#D3D3D3',
    primaryBorder: '#D3D3D3',
    secondaryBorder: '#B1A7A6',
    tertiaryBorder: '#00c8bf',
    warningBorder: '#eeac2b',
    checkboxOutline: '#F5F3F4',
    gridAltRow: '#161A1D',
    draft: '#E09F3E',
    pending: '#540B0E',
    approved: '#335C67',
    alert: '#ff0000',
    error: '#be2728',
    notificationBarBackground: '#fdf7e2',
    notificationBarText: '#99650b',
    disabledBackground: '#f6f8f9',
    activeBackground: '#96eeec',
    darkBackground: '#00415c',
    reportContainerBackground: '#F2F2F2',
    reportSysPrinSelectorBackground: '#D7E1E5',
    reportSearchCriteriaBackground: '#D8D8D8',
    landingPageCardSecondary: '#0c4f6c',
    darkRed: '#911106',
    darkGreen: '#186604',
    darkYellow: '#ffd43b',
    orange: '#ff7f27',
    endingBlue: '#177e9f',
  },
  fonts: {
    regular: 'notoSans',
    medium: 'notoSans-medium',
    semiBold: 'notoSans-semiBold',
    bold: 'notoSans-semiBold',
  },
};
